<template>
  <div class="jurisd">
    <el-form-item :label="title" class="width100" required :rules="{required: true,message: '请选择',trigger: 'change'}">
      <div class="lab" :class="{'active': item.isActive}" v-for="(item,index) in form.authCustLevel" :key="index" @click="handleActive(item, 'authCustLevel')">
        <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
      </div>
      <!-- <div class="lab" :class="{'active': item.isActive}" v-for="(item,index) in form.sysRoleList" :key="index" @click="handleActive(item)">
        <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
      </div> -->
      <div class="lab" :class="{'active': item.isActive}" v-for="(item,index) in form.authTechLevel" :key="index" @click="handleActive(item, 'authTechLevel')">
        <i class="el-icon-success" v-if="item.isActive"></i>{{item.value}}
      </div>
      <div class="lab" :class="{'active': form.isAuthInsider}" @click="handleAuthsInternal()">
        <i class="el-icon-success" v-if="form.isAuthInsider"></i>内部员工
      </div>
      <div class="lab" :class="{'active': form.isAuthSubAccount}" @click="handleAuthsSubAccount()">
        <i class="el-icon-success" v-if="form.isAuthSubAccount"></i>子账号
      </div>
    </el-form-item>

  </div>
</template>
<script>
import customerLevelApi from '@/api/sys/customerLevel'
import sysRoleApi from '@/api/sys/sysRole'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
export default {
  props: ['form', 'title'],
  data() {
    return {
      options: {
        customerLevel: [],  //   业务线-客户级别
        // registerRole: [],   //职能线-用户角色
        technicalServiceLevel: []  //技术线-技术线级别
      },
    }
  },
  created() {
    this.initOptions()
  },
  methods: {
    async initOptions() {
      // 获取客户级别
      const { data: custLevels } = await customerLevelApi.fetchList({ levelSortSign: -1 })
      // 取后端传入的已选id字符串，转换为数组
      const selectedCust = this.form.authCustLevel ? 
        (typeof this.form.authCustLevel === 'string' ? 
          this.form.authCustLevel.split(',').map(id => id.trim()) : 
          this.form.authCustLevel) : []
      let custArr = custLevels.map(item => ({
        value: item.name,
        key: item.id,
        isActive: selectedCust.includes(item.id.toString())
      }))
      this.$set(this.form, 'authCustLevel', custArr)

      // 获取技术线级别
      const { data: techLevels } = await technicalServiceLevelApi.findOptions()
      // 取后端传入的已选id字符串，转换为数组
      const selectedTech = this.form.authTechLevel ? 
        (typeof this.form.authTechLevel === 'string' ? 
          this.form.authTechLevel.split(',').map(id => id.trim()) : 
          this.form.authTechLevel) : []
      let techArr = techLevels.map(item => ({
        value: item.value,
        key: item.key,
        isActive: selectedTech.includes(item.key.toString())
      }))
      this.$set(this.form, 'authTechLevel', techArr)
    },
    handleAuthsInternal() {
      this.form.isAuthInsider = !this.form.isAuthInsider
      this.clacFuc('isAuthInsider')
      this.$forceUpdate()
    },
    handleAuthsSubAccount() {
      this.form.isAuthSubAccount = !this.form.isAuthSubAccount
      this.clacFuc('isAuthSubAccount')
      this.$forceUpdate()
    },
    handleActive(item, type) {
      // 多选逻辑
      item.isActive = !item.isActive
      this.clacFuc(item.key, type)
      this.$forceUpdate()
    },
    clacFuc(code, type) {
      // 组装选中的id数组
      const getSelectedIds = arr => arr.filter(i => i.isActive).map(i => i.key)
      const result = {
        ...this.form,
        authCustLevel: getSelectedIds(this.form.authCustLevel),
        authTechLevel: getSelectedIds(this.form.authTechLevel)
      }
      this.$emit('change', result)
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
.jurisd {
  .lab {
    font-size: 14px;
    color: #8f8e8e;
    border-radius: 4px;
    padding: 0 18px;
    display: inline-block;
    border: 1px solid #c5c5c5;
    margin: 5px;
    position: relative;
    cursor: pointer;
    &.active {
      background: #5dbde7;
      color: #fff;
      border-color: #5dbde7;
    }
    i {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>